import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Button from './Button';
import logo from '../assets/logos/vsq-logo-vectorBASEWhiteLogo.png';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showToolsMenu, setShowToolsMenu] = useState(false);

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleToolsHover = () => {
    setShowToolsMenu(true);
  };

  const handleToolsLeave = () => {
    setShowToolsMenu(false);
  };

  const toolsMenu = [
    { name: 'Performance Analysis', items: ['Portfolio Analysis', 'Portfolio Performance', 'Stock Comparison', 'Sharpe Ratio', 'Martin Ratio', 'Treynor Ratio', 'Sortino Ratio', 'Omega Ratio', 'Calmar Ratio', 'Summers Ratio'] },
    { name: 'Risk Analysis', items: ['Drawdowns', 'Expected Shortfall', 'Ulcer Index', 'Value at Risk', 'Close-to-Close Volatility', 'Parkinson Volatility', 'Garman Klass Volatility', 'Rogers-Satchell Volatility', 'Yang Zhang Volatility'] },
    { name: 'Optimization', items: ['Asset Correlations', 'Portfolio Optimization', 'Risk Parity Optimization', 'Hierarchical Risk Parity (HRP) Optimization'] },
    { name: 'Factor Model', items: ['Alpha', 'Beta'] },
    { name: 'Goal Analysis', items: ['Strategic Asset Allocation (SAA)'] },
  ];

  return (
    <header style={{
      backgroundColor: '#1e1e1e',
      color: 'white',
      padding: '1rem',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="VersaQuant" style={{ height: '40px' }} />
          </Link>
        </div>
        <nav>
          <ul style={{ listStyle: 'none', display: 'flex', gap: '1.5rem', margin: 0, padding: 0, alignItems: 'center' }}>
            {user && <li><Link to="/welcome" style={{ color: 'white', textDecoration: 'none' }}>Dashboard</Link></li>}
            <li 
              onMouseEnter={handleToolsHover}
              onMouseLeave={handleToolsLeave}
              style={{ position: 'relative' }}
            >
              <Link to="/tools" style={{ color: 'white', textDecoration: 'none' }}>Tools</Link>
              {showToolsMenu && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  backgroundColor: '#1e1e1e',
                  padding: '1.5rem',
                  borderRadius: '8px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                  zIndex: 1000,
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '2rem',
                  minWidth: '600px'
                }}>
                  {toolsMenu.map((category, index) => (
                    <div key={index}>
                      <h3 style={{ color: '#7FE7D9', marginBottom: '1rem', fontSize: '1.2rem' }}>{category.name}</h3>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {category.items.map((item, itemIndex) => (
                          <li key={itemIndex} style={{ marginBottom: '0.5rem' }}>
                            <Link 
                              to={`/tools/${category.name.toLowerCase().replace(' ', '-')}/${item.toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '')}`}
                              style={{ color: 'white', textDecoration: 'none', fontSize: '1rem', transition: 'color 0.3s' }}
                              onMouseEnter={(e) => e.currentTarget.style.color = '#7FE7D9'}
                              onMouseLeave={(e) => e.currentTarget.style.color = 'white'}
                            >
                              {item}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </li>
            <li><Link to="/portfolios" style={{ color: 'white', textDecoration: 'none' }}>Portfolios</Link></li>
            <li><Link to="/screeners" style={{ color: 'white', textDecoration: 'none' }}>Screeners</Link></li>
            <li><Link to="/discussions" style={{ color: 'white', textDecoration: 'none' }}>Discussions</Link></li>
            <li><Link to="/pricing" style={{ color: 'white', textDecoration: 'none' }}>Pricing</Link></li>
            {user ? (
              <>
                <li><Link to="/profile" style={{ color: 'white', textDecoration: 'none' }}>Profile</Link></li>
                <li><Button onClick={logout}>Logout</Button></li>
              </>
            ) : (
              <li><Button onClick={handleLoginClick}>Login</Button></li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
